
import {Action, Selector, State, StateContext} from '@ngxs/store';
import {Injectable} from '@angular/core';
import {ChangePassword, GenerateAPIKey, LoginAdmin, Logout, RegisterAdmin} from './admin-auth.action';
import {AdminAuthService} from './admin-auth.service';
import {AdminsUsers} from './entities/AdminUser';

export class AdminAuthStateModel {
  adminUser: AdminsUsers;
}

@State<AdminAuthStateModel>({
  name: 'AdminAuth',
  defaults: {
    adminUser: undefined
  }
})
@Injectable()
export class AdminAuthState {

  constructor(private authService: AdminAuthService) {}

  @Selector()
  static getAdminAuth(state: AdminAuthStateModel): any {
    return state.adminUser;
  }

  @Action(LoginAdmin)
  loginAdmin({getState, setState}: StateContext<AdminAuthStateModel>, {username, password}: LoginAdmin): any {
    return this.authService.loginWithEmail(username, password).then((result) => {
        const state = getState();
        console.log(result);
        setState({
          ...state,
          adminUser: result,
        });
      }
    );
  }

  @Action(RegisterAdmin)
  createAccount({getState, setState}: StateContext<AdminAuthStateModel>, {referralID, username, password}: RegisterAdmin): any {
    return this.authService.createNewUser(referralID, username, password).then((result) => {
        const state = getState();
        setState({
          ...state,
          adminUser: result,
        });
      }
    );
  }

  @Action(Logout)
  logout({getState, setState}: StateContext<AdminAuthStateModel>): any {
    return this.authService.logout().then((result) => {
        const state = getState();
        setState({
          ...state,
          adminUser: undefined,
        });
      }
    ).catch(error => {
      throw new Error(error.message);
    });
  }

  @Action(ChangePassword)
  changePassword({getState, setState}: StateContext<AdminAuthStateModel>, {currentPassword, newPassword}: ChangePassword): any {
    return this.authService.changePassword(currentPassword, newPassword).catch(error => {
      throw new Error(error.message);
    });
  }

  @Action(GenerateAPIKey)
  generateAPIKey({getState, setState}: StateContext<AdminAuthStateModel>): any {
    return this.authService.generateAPIKeys(getState().adminUser).then((result) => {
        const state = getState();
        setState({
          ...state,
          adminUser: result,
        });
      }
    ).catch(error => {
      throw new Error(error.message);
    });
  }
}
